import ky from 'ky';

import { setLanguageIdToRequestHeaders } from '@/shared/modules/localization';

export const request = ky.create({
  credentials: 'include', // by default: 'same-origin'
  prefixUrl: '',
  retry: 0,
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
  },
  hooks: {
    beforeRequest: [setLanguageIdToRequestHeaders],
  },
});
